import { isNil } from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { WORK_SITUATION_MAX_AGE, WORK_SITUATION_MIN_AGE } from '@/config/constants'
import {DateTimeUtil} from "@/utils/DateTime";

export const PersonUtil = {
  addTabInfoToPersons(persons) {
    return persons.map((p, idx) => {
      // only to read! don't depend on that to edit data
      p.number = idx + 1
      p.age = DateTimeUtil.getAge(p.personData.dateOfBirth)
      return p
    })
  },

  askWorkSituation(ageEndOfContractStartYear, isVVGOnly) {
    return ageEndOfContractStartYear >= WORK_SITUATION_MIN_AGE && !isVVGOnly
  },

  askIndependence(ageEndOfContractStartYear, isKVGOnly) {
    return (
      ageEndOfContractStartYear >= WORK_SITUATION_MIN_AGE &&
      ageEndOfContractStartYear <= WORK_SITUATION_MAX_AGE &&
      !isKVGOnly
    )
  },

  askSecondaryEmployment(ageEndOfContractStartYear, isKVGOnly) {
    return (
      ageEndOfContractStartYear >= WORK_SITUATION_MIN_AGE &&
      ageEndOfContractStartYear <= WORK_SITUATION_MAX_AGE &&
      !isKVGOnly
    )
  },

  createPerson(personId = uuidv4()) {
    return {
      order: null,
      collectivePersonGroup: null,
      personData: {
        dateOfBirth: null,
        firstName: null,
        lastName: null,
        gender: null,
      },
      personId,
    }
  },

  /**
   * getPersonsToValidate returns all the persons which need to be validated to proceed
   * As a basket on for an existing customer (from the service portal channel switch) always
   * contains all the persons of the contract, only the one's that have their contract modified
   * needs to be validated
   * @param basket
   * @return persons
   */
  getPersonsToValidate(basket) {
    const {existingCustomer, persons} = basket
    return existingCustomer ? persons.filter(p => p.contractModified) : persons
  },

  getWorkSituationFields(ageEndOfContractStartYear, { isVVGOnly, isKVGOnly}, workSituationData) {
    if (isNil(ageEndOfContractStartYear) || isNil(isVVGOnly) || isNil(isKVGOnly)) {
      throw new Error('Missing required parameters')
    }

    const fields = []

    if (this.askWorkSituation(ageEndOfContractStartYear, isVVGOnly)) {
      fields.push({name: 'workSituation', required: true})
    }

    if (this.askIndependence(ageEndOfContractStartYear, isKVGOnly)) {
      fields.push({name: 'workSituationJobName', required: false})
    }

    if (this.askSecondaryEmployment(ageEndOfContractStartYear, isKVGOnly)) {
      fields.push({name: 'secondaryEmployment', required: true})
      if (workSituationData.secondaryEmployment === true) {
        fields.push({name: 'professionSecondaryEmployment', required: true})
      }
    }

    return fields
  },
}
